import { STEP_FORMAT, STEP_SETTINGS } from '@/services/StepService';
import _ from 'lodash';

export default {
  dependencies: ['draftService'],
  props: {
    campaign: Object,
  },
  methods: {
    duplicate() {
      const newDraft = _.cloneDeep(this.campaign);
      delete newDraft.creator;
      delete newDraft.famCampaign;
      newDraft.details.duplicate_of_draft = this.campaign.id;
      newDraft.currentStep = STEP_FORMAT;
      this.draftService.save(newDraft).then(
        id => {
          this.$router.push({
            name: STEP_SETTINGS,
            params: { id },
          });
        },
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/duplicate-draft/DuplicateDraft.js